import { derived, Stores, StoresValues, Subscriber } from './stores/store';

function identity<T>(arg: T): T {
  return arg;
}

export function observe<S extends Stores>(stores: S, callback: Subscriber<StoresValues<S>>) {
  return derived(stores, identity).subscribe(callback as any);
}
